
var showLogTxt = 1;

//init
var gesendet = 0;
var rastatus1 = 0;
var rastatus2 = 0;
var adressFieldOpen = 0;
var LIEFERADRESSE = 0;
var bunkerTargetLabeListMain = "";
var tc = '';
var paymentB = '';

function showConsLog(logTxt){
	
	if(showLogTxt == 1){
	
		console.log(logTxt);
	
	}
	
}

function set_alnda(target, artikel){
	
	alnda_target = target;
	$("#alnda").text(decodeURIComponent(artikel));
	$("#alnda_targetx").val(target);

}

function deleteCrap(){

	var xx = str_replace("&amp;", "&", $("#alnda_targetx").val());
	location.href = xx;
	
}

function toggleLoader(show) {
	showConsLog("toggleLoader...");

	var loader = $("#site-loader-bg");

	if (show) {
		loader.fadeIn(300);
		$("body").addClass("loader-open");
		showConsLog("loader opened");

		this.loaderTimeout = setTimeout(function() {
			$("#site-loader-txt-wait").fadeIn("slow");
		}, 3000);
	} else {
		loader.fadeOut(300);
		$("body").removeClass("loader-open");
		showConsLog("loader closed");

		$("#site-loader-txt-wait").fadeOut("slow");
		clearTimeout(this.loaderTimeout);
	}
}

function checkForm(formx){

	showConsLog("checkForm:: " + formx);
	
	var test = true;

	$("#"+formx +" input:visible").each(function(){validateForm($(this));});
    $("#"+formx +" select:visible").each(function(){validateForm($(this));});

    if($("#input-country_0").val() == 0 && formx == "create_account_3" || $("#input-country_1").val() == 0 && formx == "create_account_1" ){
		test = false;
    }

	if(formx == "newpass"){
		
		//$("#newpass input").each(function(){validateForm($(this));});
		
		if($("#input-password1").val().length < 6){
			
			test = false;
			
		}

		if(!isPasswordMatch($("#input-password2").val(), $("#input-password1").val())){
			
			test = false;
			
		}
		
	}
	
	if(formx == "loginbox"){

		if(!isValidEmailAddress($("#input-login_email_address").val())){
			test = false;
		}
		/*
		if($("#input-login_email_address").val() == ""){
			
			test = false;
		}
		*/
		if($("#input-password").val() == ""){
			
			test = false;
			
		}
		
	}

	if(formx == "create_account_1" || formx == "create_account_3"){
		$("#"+formx + " input[required]:visible").each(function(){
			if($(this).val() == "")
			{
				//showConsLog($(this));
				test = false;
			}
		});

	}
	
	return test;
}

function nextPage(mtx, mode){
	
	showConsLog("nextPage:: " + mtx + " mode " + mode);

	var ok = true;
	
	if(mode == 2){
		
		ok = checkForm(mtx);
	
	}

	if(ok == true){

		toggleLoader(true);
	
		if(mtx != "" ){

			if(mode == 1){

				mtx += '.php';
				mtx = "/" + mtx;

			}	
			if(mode == 3){

				mtx = pageNames[mtx];
				mode = 1;

			}
			if(mode == 1 && mtx != "undefined" && mtx != undefined){

				showConsLog("...now going to " + mtx);
				setTimeout(function(){document.location.href = mtx}, 300);

			}

			if(mode == 2){

				gesendet = 1;
				showConsLog("submit #" + mtx);
				setTimeout(function(){$("#" + mtx).submit();}, 300);

			}

		}
	}
	else {
		parentContainer = $("#hidden-form-2, #hidden-form-1");
        var formValidated = parentContainer.find(".form-error");
        if(formValidated.length){
            if ($(window).width() < 768) {
                scrollToElement(formValidated.first(), 10);
            }
            return false;
        }
	}
	
}

function hideMe(tg){
	
	$('#' + tg).modal('hide');
				
}

function check_form(){
	
}



function clearAddressForm(what){
	
	
	
	var t = 0;
	var e = 0;
	
	if(what == 1){
	
		e = 1;
		
	}
	if(what == 1){
		
		rastatus1 = rastatus1 == 1 ? 0 : 1;
		t = rastatus1 == 1 ? 0 : 1;
		
	}	
	if(what == 2){
		
		rastatus2 = rastatus2 == 1 ? 0 : 1;
		t = rastatus2 == 1 ? 0 : 1;
	}
	
	showConsLog("clearAddressForm what " + what + " rastatus2 " + rastatus2 + " t " + t);
	
	if(t == 1){
		
		showConsLog("clear " + e);
		
		$("#input-lfirstname_" + e).val("");
		$("#input-llastname_" + e).val("");
		$("#input-lpostcode_" + e).val("");
		$("#input-lcity_" + e).val("");
		$("#input-lstreet_address_" + e).val("");
	
	}
	
}

function handle_login_return(mtx, mode, e){
	if ( e.keyCode == 13 ) {
		nextPage('loginbox', 2);
	}
}

function showAdressfield(ele){

	var container = ele.parent(".adress-field-container");
	var targetDiv = container.find(".adress-field-div:hidden");
	var targetInput = targetDiv.find("input");

	targetDiv.first().show();
	targetInput.focus();

	if(targetDiv.length <= 1)
	{
		ele.hide();
	}
}

function hideAdressfield(ele){

	var targetDiv = ele.parent(".adress-field-div");
	var addButton = ele.parents(".adress-field-container").find(".add-adress-field");
	var targetInput = targetDiv.find("input");

	targetDiv.slideUp();
	addButton.slideDown();
	targetInput.val("");
	targetInput.attr("required", false);
}


function lablistMain(w){

	var idx = $(w).attr("data-idx");
	var targetClean = $(w).attr("data-target");
	var targetx = "#t" + targetClean;
		
	var dbg = "lablistMain: idx=" + idx + " / targetx |" + targetx + "| targetClean " + targetClean + " paymentB " + paymentB;
		
	if(idx != -1){
		
		$("input[name=vidx]").val(idx);
		
	}else{	

dbg += "\n" + "A";

		if(paymentB != "" && targetx != paymentB){
dbg += "\n" + "B";				
			$(paymentB).slideUp();
				
		}

		if(paymentB != "" && targetx == paymentB){
dbg += "\n" + "C";				
			if(bunkerTargetLabeListMain != targetClean && bunkerTargetLabeListMain != ""){
dbg += "\n" + "D";				
				$("input[name='payment']").prop('checked', false);
				$(paymentB).slideUp();
				paymentB = '';
				
			}
				
		}else{
dbg += "\n" + "E";				
			$("input[name='payment']").prop('checked', false);
			$("input[name='payment'][value='" + targetClean + "']").prop('checked', true);
				
			dbg += " :: show: " + targetx;
				
			$("#targetClean").val(targetClean);
				
			bunkerTargetLabeListMain = targetClean;
				
			$(targetx).slideDown();
			paymentB = targetx;
			
		}
	}
		
	showConsLog(dbg);

}	


function openAccordion(ele, advance, evt){
	
	var idx = ele.attr("id");
	
	var dbg = "openAccordion: opener " + idx;
	
	if(idx == "llm2"){
		
		validateForm($("#loginbox"));
			
	}
	
	if(idx == undefined){
		
		dbg += "\n" + "Abbruch";
		showConsLog(dbg);
		return;
		
	}
	
	if(typeof(evt) != "undefined"){
		evt.stopPropagation();
		evt.preventDefault();
	}

	if(advance){
		 var targetAttr = ele.attr("data-hidden-form");
		 var target = $("button[data-target=" + targetAttr + "]");
		 advanceForm(target ,false);
	}

	var inputEl = ele.find("input[type=radio]");
	var hiddenDiv = inputEl.attr("data-target");
	var listOverlay = $(".label-list-main .label-list-overlay").not(ele.find(".label-list-overlay"));
		
	dbg += " hiddenDiv " + hiddenDiv;
	
	$(".label-list-main .label-list-overlay").stop().fadeOut();
	listOverlay.stop().fadeIn();

	inputEl.prop("checked", true);

	$(".hidden-content#" + hiddenDiv).toggleClass("active").slideToggle();
	$('.hidden-content').not("#" + hiddenDiv).removeClass("active").hide();

	var openLists = $(".label-list li.hidden-content.active").length;

	if(openLists > 0){
		$("#placeholder-button").parent("div").hide();
	}else{
		$("#placeholder-button").parent("div").show();
		$(".label-list-main .label-list-overlay").stop().fadeOut();
	}

	$("#" + hiddenDiv + " input").each(function(){modifyLabels($(this));});

	showConsLog(dbg);
	
}

function advanceForm(ele, validate){
	
	showConsLog("advanceForm: open " + ele.attr("id") + " validate " + validate);
	
	var targetEle = ele.attr("data-target");
	var topPos = $(".login-list").offset().top;
	var parentContainer = ele.parents('.visible-form');
	var parentList = ele.parents('.login-list').find("li.label-list-main");
	var topContainer = ele.parents('.hidden-content');

	if(validate){

		$("input[name=lgender]").attr("required", "required");
	
		parentContainer.find("input[required]").each(function(){
			validateForm($(this));
		});

		var formValidated = parentContainer.find(".form-error");

		if(formValidated.length){
		
			if ($(window).width() < 768) {
				scrollToElement(formValidated.first(), 10);
			}
			return false;
		}
	}

	//andere Loginmglichkeiten ausblenden
	if(validate){
		topContainer.find(".or-separator").remove();
		parentList.css("border", "none");
	}

	var genderRows = parentContainer.find('.gender-container');
	var companyRows = parentContainer.find('.company-name-div');
	var nameRows = parentContainer.find('.name-rows');

	var newGenderRows = genderRows.clone(true);
	var newCompanyRows = companyRows.clone(true);
	var newNameRows = nameRows.clone();

	var header = $("#" + targetEle).find('.form-header').first();
	header.after([newGenderRows, newCompanyRows, newNameRows]);

	if ($(window).width() < 768) {
		$("html, body").animate({scrollTop: topPos}, 500);
	}

	//URL-CHANGE
	var newParam = ele.attr("data-redirectparam");
	var newValue = ele.attr("data-redirectvalue");
	redirectUrl(newParam,newValue);

	if(!validate){
	
		genderRows.remove();
		companyRows.remove();
		nameRows.remove();
		$("#" + targetEle).show();
	
	}

	ele.parents('.visible-form').slideUp(1000);
	$("#" + targetEle).slideDown(1000, function(){
		genderRows.remove();
		companyRows.remove();
		nameRows.remove();
	});

	if(LIEFERADRESSE == 1){
			
		showConsLog("open lieferadresse to...");

		$("#rechnungsadresse-check1").prop("checked", true);
		//$("#rechnungsadresse-check2").prop("checked", true);
		document.getElementById("rechnungsadresse-check2").checked = true;

		$(".billing-adress-container").slideDown();

		$(".billing-adress-container").find("input").attr("required", true);
			
	}
		
}


function sendIframeForm(){
	
	//var MyIFrame = $("#hpIframe iframe");
	//showConsLog($("#hpIframe iframe").contents())
	//var MyIFrameDoc = (MyIFrame.contentWindow || MyIFrame.contentDocument);
	//if (MyIFrameDoc.document) MyIFrameDoc = MyIFrameDoc.document;	
	//MyIFrameDoc.$("#frontendForm").submit();
	//MyIFrameDoc.$("#frontendForm #send").hide();
}

function dontSubmit (e, my) {

	if ( e.keyCode == 13 ) {

		showConsLog(my);

		$(my).find("button:visible").trigger("click");
		return false; 
		
	}
}

function redirectUrl(param, value){
	var oldUrl = window.location.pathname;
	var url = oldUrl + "?" + param + "=" + value;
	showConsLog("redirectUrl: " + url);
	window.history.replaceState("", "", url);
}
	


$(document).ready(function() {

	try {
		var PaymentPageUrl = new URL(window.location.href);
		if (PaymentPageUrl.searchParams.get('payment')) {
			var selected_payment = PaymentPageUrl.searchParams.get('payment');
			$(".payment-list input[name=payment]").each(function () {
				if ($(this).val() == selected_payment) {
					$(this).prop("checked", true);
					lablistMain($("#li_" + selected_payment));
					$("#li_" + selected_payment).trigger("click");
				}
			});

		}
		if (PaymentPageUrl.searchParams.get('comment')) {
			var selected_comment = PaymentPageUrl.searchParams.get('comment');
			$("#checkout_payment textarea[name=comments]").val(selected_comment);
			$("#additional-notes-checked").css('display', 'inline');
		}
	}catch(e){}

	var afterSend = $("input[name=afterSend]").val();
	var vidx = $("#bugfixVidx").val();
	var loginFlag = $("#loginFlag").val();

	var companyVal = $("#input-company_0").val();
	if (companyVal != '') {
        var targetEle = 'company-0';
        $('#' + targetEle).slideDown();
    }

	LIEFERADRESSE = $("#LIEFERADRESSE").val();
	tc = $("#tc").val();
	
	showConsLog("afterSend=" + afterSend + " vidx=" + vidx + " loginFlag " + loginFlag + " LIEFERADRESSE " + LIEFERADRESSE);
	
	if(loginFlag == 1){
		
		var element = $("#llm2");
		openAccordion(element, false);
		validateForm($("#loginbox"));
		
		
	}
	
	if(LIEFERADRESSE == 1){
	
		rastatus1 = 1;
		rastatus2 = 1;

	}
	
	if(afterSend == 1 && tc != ""){
		
		paymentB = "#t_irgendwas";
		showConsLog("afterSend click on #li_" + tc);
		$("input[name='payment'][value='" + tc + "']").prop("checked", true).attr("checked", "checked").trigger("click");
		var element = $("#li_" + tc);
		lablistMain(element);
		
		
	}
	
	if(afterSend == 1 && vidx > 0){
	
		$('input[name="vidx"]').val(vidx);
		
		showConsLog("afterSend: vidx " + vidx + " open #llm" + vidx);
		
		var element = $("#llm" + vidx);
		openAccordion(element, false);
		
		var ele = $("#signup-button-2");
		//advanceForm(ele, true);
		
		validateForm($("#create_account_" + vidx));
		
	}
});


$(function(){


	$("#rechnungsadresse-check1").click(function(){
	
		clearAddressForm(1);
	
	});
	
	$("#rechnungsadresse-check2").click(function(){
	
		clearAddressForm(2);
	
	});
	
	$("#gutscheinBtn").click(function(){
		

		if($("#input-gutschein").val() != ""){
		
			$("#gv_redeem_code").val($("#input-gutschein").val());
			nextPage('checkout_payment', 2);
		
		}else{
		
			showConsLog("nix da");
			
		}


	});
	
	var paymentB = "";
	
	$(".label-list-main").click(function(){
		
		var element = $(this);
		lablistMain(element);
		
	});

	/*** WEITER-BUTTONS ***/
	$("button.show-hidden-form").click(function(){

		var element = $(this);
		advanceForm(element, true);
	});
	
	/*** AKKORDEON ***/
	$("#b_login .label-list li").not(".hidden-content").click(function(evt){

		var element = $(this);
		var newParam = $(this).attr("data-redirectparam");
		var newValue = $(this).attr("data-redirectvalue");
		openAccordion(element, false, evt);
		redirectUrl(newParam,newValue);

	});

	$(".add-adress-field").click(function(){
		showAdressfield($(this));
	});

	$(".form-close-icon").click(function(){
		hideAdressfield($(this));
	});


	/*** ANREDE-TABSWITCH ***/
	$(".gender-container input[type=radio]").change(function(){
	
		$(this).parents(".gender-container").find(".labelfix").removeClass("gender-success");
		$(this).next(".labelfix").addClass("gender-success");
		var nameInput = $(this).parents(".visible-form").find("input[name='lfirstname']");

		if(typeof(nameInput.attr("id")) == "undefined")	{
		
			nameInput = $(this).parents(".billing-adress-container").find("input[name='firstname']");
		
		}

		showConsLog("nameInput Label: " + nameInput.attr("id"));

		nameInput.focus();
	});
	

	/*** SHOW PW ***/
	$(".show-pw").click(function(evt){
		evt.stopPropagation();
		evt.preventDefault();

		var eleChecked = $(this).attr("data-visible");
		var targetEle = $(this).attr("data-target");
		var pwInput = $(this).parents(".form-container").find("input[name='password'], input[name='lpassword']");
		var pwIconTrue = $(this).find("span.show-pw-true");
		var pwIconFalse = $(this).find("span.show-pw-false");

		if(pwInput.attr("type") == "password"){
		
			pwInput.attr("type", "text");
			pwIconTrue.hide();
			pwIconFalse.show();
			
		}else{
		
			pwInput.attr("type", "password");
			pwIconTrue.show();
			pwIconFalse.hide();
			
		}
	});

	/*** FORM VALIDATION ***/
	$('.cs-validation input').on("focusout", function(){
		validateForm($(this));
	});
	
	$('.cs-validation input').focus(function(){
		validateForm($(this), true);
	});

	$('.cs-validation input').keydown(function(){
		var parentEle = $(this).parents(".form-container");
		if(parentEle.hasClass("form-error"))
		{
			validateForm($(this), true);
		}
	});
	
	$('.cs-validation input[type=radio]').change(function(){
		validateForm($(this));
		var radioID = $(this).attr("id");
		var labelID = $(this).siblings("label[for=" + radioID + "]")
		labelID.addClass("gender-success");
	});

	$('.cs-validation').submit(function(){
		
		if(gesendet == 0){
		
			showConsLog("submit cs-validation");
	
			$(this).find("input[required]:visible").each(function(){
				validateForm($(this));
			});
			var formValidated = $(this).find(".form-error");

			if(formValidated.length){
			
				if ($(window).width() < 768) {
					scrollToElement(formValidated.first(), 10);
				}
				return false;
			}

			var buttonTarget = $(this).find("button:visible").attr("data-target");

			if(buttonTarget == "hidden-form-1" || buttonTarget == "hidden-form-2"){
				$(this).find("button:visible").trigger("click");

				return false;
			}
		
		}

	});

	/*** FIRMA-AUFKLAPPER ***/
	$('.gender-container input[type=checkbox]').change(function(){

		var checkBox = $(this).prop("checked");
		var targetEle = $(this).attr("data-target");

		var dirx = '';
		
		if(checkBox){
			dirx = "Down";
			$('#' + targetEle).slideDown();
			$('#' + targetEle).find("input").attr("required", "required");
			
		}else{
			dirx = "Up";
			$('#' + targetEle).slideUp();
			$('#' + targetEle).find("input").removeAttr("required");
			$('#' + targetEle).find(".form-error").removeClass("form-error");
			$('#' + targetEle).find(".form-error-text").fadeOut();
		}
		
		showConsLog(".gender-container input: targetEle #" + targetEle + ": slide" + dirx);
		
	});


	/*** RECHNUNGSADRESSE ***/
	$(".rechnungsadresse-check").change(function(){
		var checkBox = $(this).prop("checked");
		var formInputs = $(".billing-adress-container").find("input");
		if(checkBox)
		{
			$(".billing-adress-container").slideDown();
			$(".billing-adress-container").find("input:visible").attr("required", true);
		}
		else
		{
			$(".billing-adress-container").slideUp();
			formInputs.attr("required", false);
			formInputs.each(function(){validateForm($(this));});
		}
		
	});
	
	/*** AGB-CHECK ***/
	$('#order-button').click(function(){
		
		var checkbox = $('input[name=agb-check]');
		var checkbox2 = $('input[name=agb-check-2]');
		var refundcheck = $('input[name=refund-check]');
		var checkboxValue = checkbox.prop('checked');
		var checkboxValue2 = checkbox2.prop('checked');
		var refundcheckValue = refundcheck.prop('checked');
		var paymentBox = $('#payment-container');
		var selectedPayment = $('input[name=payment]:checked').val();
		var submitState = $("#submitState").val();
		var error = 0;
		
		if(paymentBox.length)
		{
			if(typeof(selectedPayment) == "undefined")
			{
			
				$("#payment-header").addClass("error");
				$("#payment-container").addClass("error");
				$("#payment-error-box").slideDown();
				$("#payment-error-box2").slideDown();

				var errorMsg = $("#payment-error-box");
				scrollToElement(errorMsg, 10);
				
				error = 1;
				
			}else{
			
				$("#payment-error-box").hide();
				$("#payment-error-box2").hide();
				
			}
		}

		if(!checkboxValue && checkbox.length >= 1){
		
			$('input[name=agb-check]').parent().addClass('agb-error');
			$("#agb-error-box").slideDown();
			$("#agb-error-box2").slideDown();
			
			error = 1;
						
		}
		if(!checkboxValue2 && checkbox2.length >= 1){

			$('input[name=agb-check-2]').parent().addClass('agb-error-2');
			$("#agb-error-box").slideDown();
			$("#agb-error-box2").slideDown();

			error = 1;

		}

		if(!refundcheckValue && refundcheck.length >= 1){

			$('input[name=refund-check]').parent().addClass('refund-error');
			$("#refund-error-box").slideDown();
			error = 1;

		}
		
		showConsLog("submit... " + selectedPayment + " error " + error);
		
		if(error == 0){

			//Save user data in Mailchimp
			save_mailchimp_audience();

			//nur auf payment-return, nein immer...so ein käse
			//submitState = 2;
			
			if(submitState == 2){
			
				if(selectedPayment == "sofort_sofortueberweisung"){
	
					$('#sofort-pay-modal').modal();
					
				}else if(selectedPayment == "ideal"){
				
					$('#ideal-pay-modal').modal();
				
				}else{
				
					nextPage('checkout_process', 2);
				
				}	
				
				
			}else{
				
				nextPage('checkout_payment', 2);
				
			}
		
		}

	});
	
	$('input[name=agb-check]').change(function(){
		var agbContainer = $(this).parents(".agb-checkbox");
		if($(this).is(':checked'))
		{
			agbContainer.removeClass("agb-error");
			$("#agb-error-box").slideUp();
			$("#agb-error-box2").slideUp();
		}
	});

	$('input[name=refund-check]').change(function(){
		var agbContainer = $(this).parents(".refund-checkbox");
		if($(this).is(':checked'))
		{
			agbContainer.removeClass("refund-error");
			$("#refund-error-box").slideUp();
		}
	});

	$('input[name=agb-check-2]').change(function(){
		var agbContainer = $(this).parents(".agb-checkbox-2");
		if($(this).is(':checked'))
		{
			agbContainer.removeClass("agb-error-2");
			$("#agb-error-box").slideUp();
			$("#agb-error-box2").slideUp();
		}
	});

	$("#payment-container .label-list-main").click(function(){
		$("#payment-container").removeClass("error");
		$("#payment-header").removeClass("error");
		$("#payment-error-box").slideUp();
		$("#payment-error-box2").slideUp();

		//URL-CHANGE
		var newParam = $(this).attr("data-redirectparam");
		var newValue = $(this).attr("data-redirectvalue");
		redirectUrl(newParam,newValue);

	});

	//Anmerkungsfeld
	$('#additional-notes').click(function(){
		$('#additional-notes-div').slideToggle();
	});

	$('#additional-notes-div #additional-notes-abort').click(function(){
		$("#additional-notes-div").slideUp();
		return false;
	});

	$('#additional-notes-save').click(function(){
		$("#additional-notes-div").slideUp();
		$("#additional-notes-checked").fadeIn();
		return false;
	});

	//Reset Forms
	//$('form').each(function() { this.reset() });
	
	
	//Button-Fix
	$("button[data-submit]").click(function(){
		var submitTarget = $(this).attr("data-submit");
		$("#" + submitTarget).click();
	});

	if($(".ot_coupon.ot_couponL").length > 0)
	{
		$(".ot_coupon.ot_couponL").css("padding-top", "2px").insertAfter(".otcp2L");
		$(".ot_coupon.ot_couponR").css("padding-top", "2px").insertAfter(".otcp1R");
		$(".otcp2L").hide();
	}
	
	

	//Modal dynamische Höhe
	/*$('.modal').on('shown.bs.modal', function (e) {
		var modalBody = $(this).find(".modal-body");
		var modalHeader = $(this).find(".modal-header");
		var modalBodyHeight = ($(window).height() - modalHeader.height() - 60);
		modalBody.css("maxHeight", modalBodyHeight);
	});*/

	/*** ADRESSE BEARBEITEN ***/
	$(".edit-address, .close-address").click(function(){
		var elTarget = $(this).attr("data-target");
		$(this).parent("address").slideUp();
		$("#" + elTarget).slideDown();

		var companyCheck = $("#" + elTarget).find(".company-check-div input[type='checkbox']");
		var companyVal = $("#" + elTarget).find(".company-name-div input").val();
		if(companyVal != "")
		{
			companyCheck.trigger("click");
		}

	});

	$(".edit-address-abort, .edit-address-save").click(function(){
		$(this).parents("address").slideUp();
		$(this).parents("address").prev().slideDown();
		return false;
	});


	/*** DESKTOP-AFFIX ***/
	if ($(window).width() >= 768) {
		var affixTarget = $('#fixed-summary');
		if(affixTarget.length)
		{
			affixTarget.stickySidebar({
			topSpacing: 20,
			bottomSpacing: 20,
			containerSelector: '#page-content',
			innerWrapperSelector: '.sidebar__inner'
			});
		}
	}
	

	/*** DESKTOP-TRENNER ***/
	if ($(window).width() >= 768) {
		var pageHeight = $("#page-content").height();
		$("#cart-sum-divider").css("height", pageHeight);
	}

	/*** FOOTER-PAYMENT-TOGGLE ***/
	$(".footer-icon-pay-show").click(function(){
        $(".footer-icon-pay-show").hide();
        $(".icon-pay-hidden").show();
	});

	$(".pdx-country_code select").change(function (e) {
		var frm_cnt = $(this).parent();
		if(!isValidSelect($(this).val())){
			frm_cnt.addClass('form-error');
			frm_cnt.removeClass('form-success');
			frm_cnt.find('.form-error-text').attr('style', 'display:inline;');
			return false;
		}else{
			frm_cnt.removeClass('form-error');
			frm_cnt.addClass('form-success');
			frm_cnt.find('.form-error-text').attr('style', 'display:none;');
		}
	});
	//
    $(".btn-pdx").click(function(e){
        e.preventDefault();

        if($(this).hasClass('active')){
            $(this).removeClass('active');
        }else{
            $(this).addClass('active');
        }
        var product_id = $(this).data("product");
        var item = $(this).parent().parent();
        item.find(".items").slideToggle();
    });

    $(".btn-pdx-edit").click(function(e){
        e.preventDefault();
        var item = $(this).parent().parent().parent();
        item.find(".item-preview").hide();
		var country_code = item.find(".pdx-country_code").attr('data-countrycode');
		if(country_code != undefined && country_code != "") {
			item.find(".pdx-country_code select").val(country_code);
			item.find(".pdx-country_code").attr('data-countrycode', "");
		}
        item.find(".pdx-form").show();
    });

	$(".radiobox-style").click(function (e) {
		//$('.radiobox-content').slideUp();
		if($(this).hasClass('active')){
			$(this).removeClass('active');
			//return;
		}else {
			//$(".radiobox-style").removeClass('active');
			$(this).addClass('active');
		}
		var item = $(this).parent();
		item.find('.radiobox-content').slideToggle();
	});

	$(".btn-pdx-cancel").click(function(e){
		e.preventDefault();
		var form = $(this).parent().parent().parent();
		var item = $(this).parent().parent().parent().parent();
		var form_status = form.data('formstatus');
		if(form_status != 1) {
			form.find('.btn-pdx-submit').trigger('click');
		}else{
			item.find(".pdx-form").hide();
			item.find(".item-preview").show();
		}
	});

    $( ".pdx-form" ).submit(function(e) {
        e.preventDefault();
        var $form = $(this),
            url = $form.attr("action");

        var item = $form.parent();


		/*if(!isValidEmailAddress($form.find('input[name=email_address]').val())){
			var frm_cnt = $form.find('input[name=email_address]').parent();
			frm_cnt.addClass('form-error');
			frm_cnt.find('.form-error-text').attr('style', 'display:inline;');
		}

		if(!isValidSelect($form.find('select[name=country_code]').val())){
			var frm_cnt = $form.find('select[name=country_code]').parent();
			frm_cnt.addClass('form-error');
			frm_cnt.removeClass('form-success');
			frm_cnt.find('.form-error-text').attr('style', 'display:inline;');
			return false;
		}else{
			var frm_cnt = $form.find('select[name=country_code]').parent();
			frm_cnt.removeClass('form-error');
			frm_cnt.addClass('form-success');
			frm_cnt.find('.form-error-text').attr('style', 'display:none;');
		}

		if($form.find('select[name=country_code_val]') !== undefined){
			var cc_error_msg = $form.find('.error-country-code');
			var cc = $form.find('select[name=country_code_val]').val();
			if(cc == 0) {
				var frm_cnt = $form.find('select[name=country_code_val]').parent();
				frm_cnt.addClass('form-error');
				frm_cnt.removeClass('form-success');
				frm_cnt.find('.form-error-text').attr('style', 'display:inline;');
				cc_error_msg.show();
				return false;
			}else{
				var frm_cnt = $form.find('select[name=country_code_val]').parent();
				frm_cnt.removeClass('form-error');
				frm_cnt.addClass('form-success');
				frm_cnt.find('.form-error-text').attr('style', 'display:none;');
				cc_error_msg.hide();
			}
		}


		if($form.find('select[name=dob_day]') !== undefined){
			var dob_error_msg = $form.find('.date-error');
			var dob_day = $form.find('select[name=dob_day]').val();
			var dob_month = $form.find('select[name=dob_month]').val();
			var dob_year = $form.find('select[name=dob_year]').val();
			if(dob_day == 0 || dob_month == 0 || dob_year == 0) {
				var frm_cnt = $form.find('select[name=dob_day]').parent();
				frm_cnt.addClass('form-error');
				frm_cnt.removeClass('form-success');
				frm_cnt.find('.form-error-text').attr('style', 'display:inline;');

				var frm_cnt = $form.find('select[name=dob_month]').parent();
				frm_cnt.addClass('form-error');
				frm_cnt.removeClass('form-success');
				frm_cnt.find('.form-error-text').attr('style', 'display:inline;');

				var frm_cnt = $form.find('select[name=dob_year]').parent();
				frm_cnt.addClass('form-error');
				frm_cnt.removeClass('form-success');
				frm_cnt.find('.form-error-text').attr('style', 'display:inline;');
				dob_error_msg.show();
				return false;
			}else{
				var frm_cnt = $form.find('select[name=dob_day]').parent();
				frm_cnt.removeClass('form-error');
				frm_cnt.addClass('form-success');
				frm_cnt.find('.form-error-text').attr('style', 'display:none;');

				var frm_cnt = $form.find('select[name=dob_month]').parent();
				frm_cnt.removeClass('form-error');
				frm_cnt.addClass('form-success');
				frm_cnt.find('.form-error-text').attr('style', 'display:none;');

				var frm_cnt = $form.find('select[name=dob_year]').parent();
				frm_cnt.removeClass('form-error');
				frm_cnt.addClass('form-success');
				frm_cnt.find('.form-error-text').attr('style', 'display:none;');
				dob_error_msg.hide();
			}
		}*/

        var data = {
            gender:  $form.find('input[name=gender]:checked').val(),
            firstname:  $form.find('input[name=firstname]').val(),
            lastname:  $form.find('input[name=lastname]').val(),
			email_address:  $form.find('input[name=email_address]').val(),
			telephone_number:  $form.find('input[name=telephone_number]').val(),
			country_code:  $form.find('select[name=country_code] ').val(),
			country:  $form.find('select[name=country_code] option:selected').text(),
            street_address:  $form.find('input[name=street_address]').val(),
			street_house_number:  $form.find('input[name=street_house_number]').val(),
            postcode:  $form.find('input[name=postcode]').val(),
            city:  $form.find('input[name=city]').val(),
			dob_day: $form.find('select[name=dob_day]').val(),
			dob_month: $form.find('select[name=dob_month]').val(),
			dob_year: $form.find('select[name=dob_year]').val(),
			dob: $form.find('select[name=dob_day]').val() + '-' +  $form.find('select[name=dob_month]').val() + '-' + $form.find('select[name=dob_year]').val(),
			passport_number:  $form.find('input[name=passport_number]').val(),
			country_code_val:  $form.find('select[name=country_code_val]').val(),
			tents:  $form.find('input[name=tents]').val(),
			camper_van:  $form.find('input[name=camper_van]').val(),
			caravan:  $form.find('input[name=caravan]').val(),
			weight: $form.find('select[name=weight] option:selected').text(),
			country_code_val:  $form.find('select[name=country_code_val]').val(),
			orders_id: $form.find('input[name=orders_id]').val(),
            product_id: $form.find('input[name=product_id]').val(),
            index_id:  $form.find('input[name=index_id]').val(),
            ajax:  true
        };

        $.ajax({
            method: "POST",
            url: url,
            data: data,
            dataType:"json"
        }).done(function( response ) {
			// console.log(data);

            if(response.response == "OK") {
                var html = '';

				if (data.firstname != "undefined" && data.firstname != "" && data.firstname != null) {
					html += data.firstname + ' ';
				}
				if (data.lastname != "undefined" && data.lastname != "" && data.lastname != null) {
					html += data.lastname;
				}
				if (data.email_address != "undefined" && data.email_address != "" && data.email_address != null) {
					html += '<br>' + data.email_address;
				}
				if (data.country_code_val != "0" && data.country_code_val != "undefined" && data.country_code_val != "" && data.country_code_val != null) {
					html += '<br>' + data.country_code_val;
				}
				if (data.telephone_number != "undefined" && data.telephone_number != "" && data.telephone_number != null) {
					html += '<br>' + data.telephone_number;
				}
				if (data.street_address != "undefined" && data.street_address != "" && data.street_address != null) {
					html += '<br>' + data.street_address;
				}
				if (data.street_house_number != "undefined" && data.street_house_number != "" && data.street_house_number != null) {
					html += '<br>' + data.street_house_number;
				}
				if (data.city != "undefined" && data.city != "" && data.city != null) {
					html += '<br>' + data.city;
				}
				if (data.postcode != "undefined" && data.postcode != "" && data.postcode != null) {
					html += '<br>' + data.postcode;
				}
				if (data.country != "undefined" && data.country != "" && data.country != null && data.country != "Please select country") {
					html += '<br>' + data.country;
				}
				if (data.dob_day != "0" && data.dob_day != "undefined" && data.dob_day != "" && data.dob_day != null &&
					data.dob_month != "0" && data.dob_month != "undefined" && data.dob_month != "" && data.dob_month != null &&
					data.dob_year != "0" && data.dob_year != "undefined" && data.dob_year != "" && data.dob_year != null ) {
					html += '<br>' + data.dob_day +"-"+data.dob_month +"-"+data.dob_year;
				}
				if (data.passport_number != "undefined" && data.passport_number != "" && data.passport_number != null) {
					html += '<br>' + data.passport_number;
				}

				if (data.tents != "undefined" && data.tents != "" && data.tents != null) {
					html += '<br>' + data.tents;
				}

				if (data.camper_van != "undefined" && data.camper_van != "" && data.camper_van != null) {
					html += '<br>' + data.camper_van;
				}

				if (data.weight != "undefined" && data.weight != "" && data.weight != null) {
					html += '<br>' + data.weight;
				}

				if (data.caravan != "undefined" && data.caravan != "" && data.caravan != null) {
					html += '<br>' + data.caravan;
				} else {
					html += '<br>';
				}


                item.find(".item-body").html(html);
                item.find(".pdx-form").hide();
                item.find(".item-preview").show();
				$form.attr('data-formstatus', '1');

                if(response.personalisation_checked){
                    $('.pdx-submit').show();
                    $('.pdx-submit').find('button').removeAttr('disabled');
                }

            }else if(response.error) {
                alert(response.error);
            }else if(response.redirect) {
                location.href = response.redirect;
            }
        }).error(function( msg ) {
                console.log( "error: " + msg );
        });
    });

	$(".btn-refund_protect").click(function(e){

		toggleLoader(true);

		var data = {
			action:  "refund_protect",
			ajax:  true
		};

		$.ajax({
			method: "POST",
			url: "",
			data: data,
			dataType:"html"
		}).done(function( response ) {
			if(response.response == "OK") {
				var html = '';
			}
			var selected_payment = $(".payment-list input[name=payment]:checked").val();
			var selected_comments = $("#checkout_payment textarea[name=comments]").val();
			var mtx_page = pageNames['payment'];
			if(selected_payment !== undefined) {
				mtx_page += '?payment=' + selected_payment;
			}
			if(selected_comments !== undefined && selected_comments != '') {
				if(selected_payment === undefined) {
					mtx_page += '?comment=' + selected_comments;
				}else {
					mtx_page += '&comment=' + selected_comments;
				}
			}
			showConsLog("...now going to " + mtx_page);
			toggleLoader(false);
			setTimeout(function(){document.location.href = mtx_page}, 300);
			//nextPage('payment', 3);
		}).error(function( msg ) {
			console.log( "error: " + msg );
		});

	});

	$(document).on("click", ".btn-refund_protect_shopping", function(e){

		toggleLoader(true);
		const nextPageTarget = $(this).data('target');
		var data = {
			action:  "refund_protect",
			ajax:  true
		};

		$.ajax({
			method: "POST",
			url: "",
			data: data,
			dataType:"html"
		}).done(function( response ) {
			if (nextPageTarget) {
				location.reload();
			} else {
				let responsePagecontainer = $(response).find('#page-container').html();
				$("#page-container").html(responsePagecontainer);
				toggleLoader(false);
			}
		}).error(function( msg ) {
			console.log( "error: " + msg );
			toggleLoader(false); 
		});

	});

	$(document).on("click", ".btn-best_seats_shopping", function(e) {
		
		toggleLoader(true);
	
		const nextPageTarget = $(this).data('target');
	
		let data = {
			action: "best_seats",
			ajax: true
		};
	
		$.ajax({
			method: "POST",
			url: "",
			data: data,
			dataType: "html"
		}).done(function(response) {
			if (nextPageTarget) {
				location.reload();
			} else {
				let responsePagecontainer = $(response).find('#page-container').html();
				$("#page-container").html(responsePagecontainer);
				toggleLoader(false);
			}
		}).fail(function(msg) {
			console.log("error: " + msg);
			toggleLoader(false);
		});
	});

	$(document).on('click', '.proceed-to-checkout-btn, .proceed-to-personalisation-btn', function(e) {
		let flexCheckbox = $('.btn-refund_protect_shopping');

		if(flexCheckbox.length === 0 || flexCheckbox.prop('checked')) {
			// Flex isn't available or it's already selected
			proceedToCheckout();
		} else {
			$('#risk-modal').modal('show');
		}
	});

	$(document).on('show.bs.modal', '#risk-modal', function() {
		// Prevent closing the modal by clicking outside of it or pressing the ESC key
		$(this).data('bs.modal').options.keyboard = false;
		$(this).data('bs.modal').options.backdrop = 'static';

		setTimeout(function() {
			// Ensure that the class is added to the body, to prevent scrolling
			$('body').toggleClass('modal-open', true);
		});
	});

	$(document).on('click', '#risk-modal .risk-btn, #risk-modal .cover-btn', function() {
		if($(this).hasClass('cover-btn')) {
			let mutation = new MutationObserver(function (mutations, mut) {
				// Detect when the loader is closed before proceeding to checkout, to make sure the flex addon got enabled in the backend session
				if (mutations[0]?.oldValue?.indexOf('loader-open') !== -1) {
					mut.disconnect();
					proceedToCheckout();
				}
			});
			mutation.observe(document.querySelector('body'), { attributeFilter: ['class'], attributeOldValue: true });

			$('.btn-refund_protect_shopping').trigger('click');
		} else {
			proceedToCheckout();
		}
	});

	function proceedToCheckout() {
		pushCart('begin_checkout');

		if($('.proceed-to-checkout-btn').length) {
			nextPage('checkout_shipping', 1);
		} else if($('.proceed-to-personalisation-btn').length) {
			nextPage('checkout_personalisation', 3);
		}
	}

	$(document).on('hide.bs.modal', '#flex-info-modal', function() {
		// Open the risk modal after closing the flex info modal
		$('#risk-modal').modal('show');
	});

	/**
	 * Delivery address change
	 * Open state selection if Spain is selected
	 */
	$(document).on("change", "#input-lcountry", function() {
		if (Number($(this).val()) === 195) {
			$("#state-row").fadeIn();
		}
		else {
			$("#state-row").fadeOut();
		}
	});

	// Show more/less legal text
	$('#legal-text + .read-link-container').on('click', function() {
		$(this).prev('#legal-text').toggleClass('open');
		$(this).toggleClass('more less');
	});
});

function scrollToElement(ele, eHeight){
	$("html, body").animate({scrollTop: (ele.offset().top) - eHeight}, 500);
}

function modifyLabels(ele){

	//showConsLog("modifyLabels: val: " + ele.val() + "id: " + ele.val());

	var formLabel = ele.nextAll('label.folding-label');

	if(ele.val() == "")
	{
		formLabel.removeClass('modified');
	}
	else
	{
		formLabel.addClass('modified');
	}
}


function validateForm(ele, focusIn){

	showConsLog("validateForm: " + ele.attr("id"));
	
	var parentContainer = ele.parents('.form-container');
	var formLabel = ele.nextAll('label.folding-label');
	var requiredInput = ele.prop('required');
	var errorMessage = parentContainer.find('.form-error-text');
	var detailMessage = parentContainer.find('.form-detail-text');
	var successIcon = parentContainer.find('.form-success-icon');
    var selectIcon = parentContainer.find('.select-icon');

	if(focusIn){

		formLabel.addClass('modified');
		parentContainer.removeClass('form-error');
		parentContainer.removeClass('form-success');
		errorMessage.hide();
		detailMessage.hide();
		successIcon.hide();

	}else{

		var validated = false;

		if(ele.val() == ""){
			formLabel.removeClass('modified');
		}
		if(ele.attr("type") == "email"){
		
			validated = isValidEmailAddress(ele.val());
		}else if($(ele).is('select')){
			validated = isValidSelect(ele.val());
   		}
		else if(ele.attr("type") == "radio"){
		
			validated = isValidRadio(ele.attr("name"));
			
		}else if(ele.attr("type") == "password"){

			if(ele.attr("id") == "input-password")
			{
				validated = isValidInput(ele.val());
			}
			else if(ele.attr("id") == "input-password2")
			{
				validated = isPasswordMatch(ele.val(), $("#input-password1").val());
			}
			else
			{
				if(ele.val().length > 5){
					
					validated = true;		
					
				}
			}
			
		}else {
		
			validated = isValidInput(ele.val());
			
		}

		if(validated){
			console.log(ele.val());
			formLabel.addClass('modified');
			parentContainer.removeClass('form-error');
			parentContainer.addClass('form-success');
			errorMessage.hide();
			detailMessage.fadeIn();
			successIcon.fadeIn();
            selectIcon.hide();

			if (String(ele.attr("id")) === "input-country_0") {
				if (
					String(ele.val()) === '195' ||
					Number(ele.val()) === 195 ||
					ele.val() === 195 ||
					ele.val() === '195'
				) {
					$("#" + ele.closest('.hidden-form').attr('id')).find("#state-row").fadeIn();
				}
				else {
					$("#" + ele.closest('.hidden-form').attr('id')).find("#state-row").fadeOut();
				}
			}
			return true;
			
		}else{
		
			if(requiredInput == "")	{
				parentContainer.removeClass('form-error');
				errorMessage.hide();
				return true;
			}
			parentContainer.addClass('form-error');
			parentContainer.removeClass('form-success');
			detailMessage.hide();
			errorMessage.fadeIn();
			successIcon.fadeOut();
            selectIcon.show();
			return false;
		}
	}
}

function isValidEmailAddress(emailAddress) {

	//var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;

	//Does not support special characters other than . _ -
	var pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

	return pattern.test(emailAddress);

}

function isValidSelect(selectOption){
    if(selectOption == "0"){

        return false;

    }else{

        return true;
    }
}

function isValidRadio(attrName){

	if($("input:radio[name='" + attrName + "']").is(":checked")){
	
		return true;
		
	}else{
	
		return false;
		
	}
}

function isPasswordMatch(inputVal, matchVal){

	if(inputVal == matchVal){
	
		return true;
		
	}else{
	
		return false;
		
	}
}

function isValidInput(inputVal){

	if(inputVal != ""){
	
		return true;
		
	}else{
	
		return false;
		
	}
}

function save_mailchimp_audience() {
	$.ajax({
		method:"POST",
		dataType:"json",
		url:"save_mailchimp_audience.php",
	}).done(function( response ) {
		if(response.title) {
			showConsLog("Mailchimp message : " + response.detail);
		} else {
			showConsLog("Data successfully saved on Mailchimp.");
		}
	}).error(function( msg ) {
		showConsLog("Error occurred while saving data on Mailchimp: " + msg);
	});
}

const GTCounter = function(){
	const counter_box = document.getElementById('clock-countdown');
	let CounterEndAt = null;
	let intId = null;
	let  callback = null;

	this.onComplete = function (e) {
		callback = e;
	};

	this.start = function () {
		if(!counter_box) return; // Prevent initialization if the element is not found in the page
		return StartTime();
	};

	this.setTime = function(seconds){
		const time = new Date();
		time.setSeconds(time.getSeconds() + seconds);
		CounterEndAt = time;
	}

	function countdown(){
		const time = new Date();
		const remaing = Math.abs(CounterEndAt - time) / 1000;
		const minutes = Math.floor(remaing / 60) % 60;
		const seconds =  Math.floor((remaing - (minutes * 60)) % 60);

		counter_box.innerHTML = ('0' + minutes).slice(-2) +':' + ('0' + seconds).slice(-2);

		if(Math.floor(remaing) == 0){
			clearInterval(intId);
			callback();
		}
	}

	function StartTime(){
		countdown();
		intId = setInterval(function(){
			countdown();
		}, 1000);
	}
}

$(document).ready(function(){
	$('.choose-us ul li.info').on('click', function(e) {
		e.preventDefault();
		$(this).children("#" + $(this).attr("id") + ".usp_paragraph").toggle();
	});

	$(".mlPlusMinIcons").on("click", function() {

		if ($(this).attr('src') === '/media/icon-min.svg') {
			$(this).attr('src', '/media/icon-plus.svg');
		} else {
			$(this).attr('src', '/media/icon-min.svg');
		}

		 // Find the value of the 'data-target' attribute of the clicked element
		 var targetId = $(this).attr('data-target');

		 // Use the found value to select the elements with the matching ID and toggle their visibility
		 $('[id="' + targetId + '"]').each(function() {
			 $(this).toggle();
		 });
	});
});